package fr.manyverse.app.infrastructure.cache

import fr.manyverse.app.domain.model.SignedUrlCacheEntry
import fr.manyverse.app.domain.repository.SignedUrlCacheRepository
import kotlin.time.Clock

/**
 * In-memory cache for signed URLs.
 * Stores signed URLs with their expiration times to avoid repeated Supabase Storage API calls.
 */
class SignedUrlCache : SignedUrlCacheRepository {
    private val cache = mutableMapOf<String, SignedUrlCacheEntry>()

    override fun get(storagePath: String): SignedUrlCacheEntry? {
        val entry = cache[storagePath] ?: return null

        // Check if expired
        if (Clock.System.now() >= entry.expiresAt) {
            cache.remove(storagePath)
            return null
        }

        return entry
    }

    override fun put(storagePath: String, entry: SignedUrlCacheEntry) {
        cache[storagePath] = entry
    }

    override fun remove(storagePath: String) {
        cache.remove(storagePath)
    }

    override fun clear() {
        cache.clear()
    }

    override fun evictExpired() {
        val currentTime = Clock.System.now()
        cache.entries.removeAll { (_, entry) ->
            currentTime >= entry.expiresAt
        }
    }
}
